const reducer = (key, value) => {
    switch (key) {
        case 'id':
            if (typeof value !== 'string' || value.length !== 12) return 'ID must be 12 characters'
            break
        case 'mac':
            if (typeof value !== 'string' || value.length !== 17) return 'Must be 12 hex characters'
            break
        case 'api_url':
            if (typeof value !== 'string' || value.length > 100 || value.length < 1) return `It must be a character string with a maximun of 100 characters`
            break
        case 'socket_url':
            if (typeof value !== 'string' || value.length > 100 || value.length < 1) return `It must be a character string with a maximun of 100 characters`
            break
        case 'file_url':
            if (typeof value !== 'string' || value.length > 100 || value.length < 1) return `It must be a character string with a maximun of 100 characters`
            break
        case 'sync_url':
            if (typeof value !== 'string' || value.length > 100 || value.length < 1) return `It must be a character string with a maximun of 100 characters`
            break
        case 'ntp_url':
            if (typeof value !== 'string' || value.length > 100) return `It must be a character string with a maximun of 100 characters`
            break
        case 'file_auth':
            if (typeof value !== 'string' || (value !== 'true' && value !== 'false')) return `Must be true or false`
            break
        case 'store_sync':
            if (typeof value !== 'string' && value !== 'true' && value !== 'false') return `Must be true or false`
            break
        case 'store_code':
            if (typeof value !== 'string') return `Must be a character string`
            break
        case 'layer_enabled':
            if (typeof value !== 'string' && value !== 'true' && value !== 'false') return `Must be true or false`
            break
        case 'layer_extra':
            if (typeof value === 'string') {
                try {
                    JSON.parse(value)
                } catch (e) {
                    return `Must be a character string in JSON format`
                }
            } else return `Must be a character string in JSON format`
            break
        case 'volume':
            if (typeof value !== 'string' || value.length > 10 || Number.isNaN(Number(value))) return `Must be a number string with a maximun of 10 digits`
            break
        case 'selected_channel':
            if (typeof value !== 'string' || value > 50) return `Must be a character string with a maximun of 50 characters`
            break
        case 'background_colour':
            if (typeof value !== 'string' || value.length > 10) return `Must be a character string with a maximun of 10 characters`
            break
        case 'sync_delay':
            if (typeof value !== 'string' || Number.isNaN(Number(value))) return `Must be a number`
            break
        case 'sync_offset':
            if (typeof value !== 'string' || Number.isNaN(Number(value))) return `Must be a number`
            break
        case 'sync_timeout':
            if (typeof value !== 'string' || Number.isNaN(Number(value))) return `Must be a number`
            break
        case 'screen_rotation':
            if (typeof value !== 'string' || value.length > 20) return `Must be a character string with a maximun of 20 characters`
            break
        case 'working_close':
            if (typeof value !== 'string' || value.length > 4 || Number.isNaN(Number(value))) return `Must be a number with a maximun of 4 digits`
            break
        case 'working_open':
            if (typeof value !== 'string' || value.length > 4 || Number.isNaN(Number(value))) return `Must be a number with a maximun of 4 digits`
            break
        case 'device_owner':
            if (typeof value !== 'string' && value !== 'true' && value !== 'false') return `Must be true or false`
            break
        case 'key_wifi_networks':
            if (typeof value === 'string') {
                try {
                    JSON.parse(value)
                } catch (e) {
                    return `Must be a character string in JSON format`
                }
            } else return `Must be a character string in JSON format`
            break
        default:
            return null
    }
}

const validate = (values) => ({
    ...Object.keys(values).reduce((obj, k) => {
        const out = obj
        const error = reducer(k, values[k])
        if (error) out[k] = error
        return obj
    }, {}),
})

export default validate
